<template>
  <div id="scroll-target">
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0">
        <b-form-select
          style="width: 300px"
          v-model="form_id"
          :options="forms"
          class="mt-1"
          @change="onFormChanged()"
        />
        <!--
        <b-form-select
          style="width:300px;"
          v-model="question_id"
          :options="questions"
          class="mt-1 ml-2"
          @change="onFormChanged()"
        />
        -->
      </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <ul class="demo-alignment pb-0" style="float: right">
            <!-- 
            <li>
              <vs-checkbox
                v-model="published_only"
                color="primary"
                :vs-value="true"
                @change="refreshTable()"
                >Published Only</vs-checkbox
              >
            </li>
            -->
            <li class="pl-4 border-0 border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :fields="columns"
        :items="dataProvider"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
        :no-provider-sorting="true"
      >
        <template v-slot:cell(created_at)="data">
          <div style="width: 120px">{{ data.value }}</div>
        </template>

        <template v-slot:cell(question_title)="data">
          <div style="width: 200px">{{ data.value }}</div>
        </template>

        <template v-slot:cell(answer)="data">
          <div style="width: 400px; overflow: " class="wrap">
            {{ data.value.trim() }}
          </div>
        </template>

        <template v-slot:cell(status)="data">
          <div>
            <vs-chip
              :color="`danger`"
              style="width: 135px"
              v-if="data.value == 'deleted'"
              >Deleted</vs-chip
            >
            <vs-chip style="width: 135px" v-if="data.value == 'draft'"
              >Draft</vs-chip
            >
            <vs-chip
              :color="`success`"
              style="width: 135px"
              v-if="data.value == 'published'"
              >Published</vs-chip
            >
          </div>
        </template>
        v
        <template v-slot:cell(created_datetime)="data">
          <div style="width: 120px">{{ data.value }}</div>
        </template>
        <template v-slot:cell(published_datetime)="data">
          <div style="width: 120px">{{ data.value }}</div>
        </template>
        <template v-slot:cell(trashed_datetime)="data">
          <div style="width: 120px">{{ data.value }}</div>
        </template>

        <!-- A custom formatted footer cell for field 'name' -->
        <template #foot()="data">
          <div style="font-weight: bolder; font-size: 1.1rem">
            <b>{{ data.field.foot }}</b>
          </div>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>
      </b-table>

      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
import moment from "moment";
export default {
  components: {},
  data: () => ({
    order_id: null,
    isBusy: false,
    showPagination: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    fields: [],
    columns: [
      {
        label: "Status",
        key: "status",
        sortable: true,
        foot: "",
      },
      { label: "Ticket", key: "ticket", sortable: true, foot: "" },
      { label: "Name", key: "fullname", sortable: true, foot: "" },
      // { label: "Area", key: "area", sortable: true, foot: "" },
      // { label: "Club", key: "club", sortable: true, foot: "" },
      {
        label: "Created Date",
        key: "created_datetime",
        sortable: true,
        foot: "",
      },
      // {
      //   label: "Published Date",
      //   key: "published_datetime",
      //   sortable: true,
      //   foot: ""
      // },
      {
        label: "Trashed Date",
        key: "trashed_datetime",
        sortable: true,
        foot: "",
      },

      /*
      { label: "Round", key: "round", sortable: true, foot: "" },
      { label: "Trashed", key: "trashed_at", sortable: true, foot: "" }
      */
    ],
    footer: [],
    items: [],
    form_id: null,
    question_id: null,
    forms: [],
    rounds: [1],
    questions: [{ text: "All Questions", value: null }],
    published_only: false,
    answerOptions: [],
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;

    this.getForms();
  },
  methods: {
    debounceInput: _.debounce(function (e) {
      this.filter = e;
      this.search = e;
    }, 500),
    getForms() {
      let data = {
        e: this.$route.query.e,
      };
      let params = Object.keys(data)
        .map((key) => key + "=" + data[key])
        .join("&");

      Service.Vote.forms(params).then((res) => {
        this.forms = res.data.rows.map((item) => {
          return { text: item.form_title, value: item.form_id };
        });
        this.form_id = this.forms[0].value;

        Service.Vote.formDetail(this.form_id, params).then((res) => {
          /*
          this.forms = res.data.rows.map(item => {
            return { text: item.form_title, value: item.form_id };
          });
          */
          res.data.rows[0].questions.map((q) => {
            this.columns.push({
              label: q.question_title,
              key: "answer_" + q.question_id,
              sortable: true,
              foot: "",
            });
          });

          this.form_id = this.forms[0].value;
          this.$refs.table.refresh();
        });
      });
    },
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e,
          form_id: this.form_id,
          is_published: this.published_only,
        };

        let params = Object.keys(data)
          .map((key) => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map((key) => key + "=" + ctx[key])
            .join("&");

        this.columns = [
          {
            label: "Status",
            key: "status",
            sortable: true,
            foot: "",
          },
          { label: "Ticket", key: "ticket", sortable: true, foot: "" },
          { label: "Name", key: "fullname", sortable: true, foot: "" },
          // { label: "Area", key: "area", sortable: true, foot: "" },
          // { label: "Club", key: "club", sortable: true, foot: "" },
          {
            label: "Created Date",
            key: "created_datetime",
            sortable: true,
            foot: "",
          },
          {
            label: "Published Date",
            key: "published_datetime",
            sortable: true,
            foot: "",
          },
          {
            label: "Trashed Date",
            key: "trashed_datetime",
            sortable: true,
            foot: "",
          },
        ];

        return Service.Vote.formDetail(this.form_id, params).then((res) => {
          res.data.rows[0].questions.map((q) => {
            this.columns.push({
              label: q.question_title,
              key: "answer_" + q.question_id,
              sortable: true,
              foot: "",
            });
          });

          return Service.Vote.answers(params)
            .then((res) => {
              let rows = res.data.rows.map((item) => {
                return { ...item, ticketcode: item.ticket.ticket };
              });

              let statusList = [];
              this.data = [];
              statusList.push(rows.filter((x) => x.status == "published"));
              statusList.push(rows.filter((x) => x.status == "draft"));
              //statusList.push(rows.filter(x => x.status == "deleted"));

              statusList.map((list) => {
                if (list.length > 0) {
                  var grouped = null;

                  if (list[0].status == "published") {
                    grouped = list.reduce(function (obj, item) {
                      obj[item.published_reference] =
                        obj[item.published_reference] || [];
                      obj[item.published_reference].push({
                        ...item,
                      });
                      return obj;
                    }, {});
                  } else {
                    grouped = list.reduce(function (obj, item) {
                      obj[item.ticketcode] = obj[item.ticketcode] || [];
                      obj[item.ticketcode].push({
                        ...item,
                      });
                      return obj;
                    }, {});
                  }

                  var myArray = Object;
                  myArray = Object.keys(grouped).map((key, key_i) => {
                    let published_datetime = "";
                    let trashed_datetime = "";

                    if (grouped[key][0].published_at) {
                      published_datetime = moment(grouped[key][0].published_at)
                        .add("hours", 7)
                        .format("YYYY-MM-DD HH:mm");
                    }

                    let created_datetime = moment(grouped[key][0].created_at)
                      .add("hours", 7)
                      .format("YYYY-MM-DD HH:mm");

                    if (grouped[key][0].trashed_at) {
                      trashed_datetime = moment(grouped[key][0].trashed_at)
                        .add("hours", 7)
                        .format("YYYY-MM-DD HH:mm");
                    }

                    let row = {
                      index: key_i + 1,
                      status: grouped[key][0].status,
                      ticket: grouped[key][0].ticket.ticket,
                      area: grouped[key][0].ticket.field_a1,
                      club: grouped[key][0].ticket.field_a2,
                      fullname:
                        grouped[key][0].ticket.firstName +
                        " " +
                        grouped[key][0].ticket.lastName,
                      published_datetime: published_datetime,
                      created_datetime: created_datetime,
                      trashed_datetime: trashed_datetime,
                    };

                    grouped[key].map((item, index) => {
                      let a = item.answer.split(";");
                      row["answer_" + item.question.question_id] =
                        a.join(",\r\n\n");
                    });

                    console.log(row);
                    this.data.push(row);
                  });
                }
              });

              callback(this.data);
            })
            .catch((error) => {
              console.log(error);
              callback([]);
            });
        });
      }, 500);
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    onFormChanged() {
      this.$refs.table.refresh();
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      rows = this.data.map((item, index) => {
        let data = {};
        let datetime = null;
        this.columns.map((col) => {
          //console.log(item[col.key]);

          if (col.key.split("_")[0] == "answer") {
            let found = this.columns.find((x) => x.key == col.key);
            data[found.label] = item[col.key];
          } else {
            data[col.key] = item[col.key];
          }
        });

        if (item.is_published) {
          datetime = item.published_at;
        } else {
          datetime = item.create_at;
        }
        /*
        let data = {
          Status: item.status,
          Ticket: item.ticket.ticket,
          Name: item.ticket.firstName + " " + item.ticket.lastName,
          Area: item.ticket.field_a1,
          Club: item.ticket.field_a2,
          Date: datetime
        };
        */

        return data;
      });

      let filename = this.forms.find((x) => x.value == this.form_id).text;

      let dataExport = {};
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "vote_report_" + filename + ".xlsx");
      this.$vs.loading.close();
    },
  },
};
</script>
